/* unplugin-vue-components disabled */import script from "./ZeroTax.vue?vue&type=script&setup=true&lang=js"
export * from "./ZeroTax.vue?vue&type=script&setup=true&lang=js"

import "./ZeroTax.vue?vue&type=style&index=0&id=e3ddf220&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3ddf220"]])

export default __exports__